<div class="position-reletivediv">
    <div class="popup-inner-space">
        <div class="betweenheader"> Threshold value </div>
        <div class="text-right flow-right"><img src="assets/images/close.svg" alt="..."
                class="img-fluid closeicon2 cursor-pointer" (click)="Close()"></div>
    </div>
    <form class="my-custom-scrollbar-thershold" [formGroup]="setparameterForm" id="setparameterForm">
        <div class="errmsg" *ngIf="errorMsg">{{errorMsg}}</div>
        <div class="sucessmsg" *ngIf="successMsg">{{successMsg}}</div>
        <div class="row">

            <div class="fxg-field margin-top-5 col-lg-6 padding-space" *ngFor="let lstvalue of RegisterList">
                <label style="display:none;" class="Navuser">{{lstvalue.RegisterName}}
                </label>
                <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    formControlName={{lstvalue.RegisterName}} id={{lstvalue.RegisterName}} NumberWithDecimal maxlength="50"
                    name={{lstvalue.RegisterName}} required="" aria-required="true"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
                <span class="fxg-field__placeholder fxg-field__placeholder12 fxg-field__floating-placeholder"
                    tabindex="-1">{{lstvalue.RegisterName}}</span>
                <div style="position: relative;">
                </div>
            </div>
        </div>
    </form>

    <div class="setfloat-btn margin-top-20" *ngIf="DisplayButton">
        <button class="btncommon btn-bg-blue" (click)="OnSubmit()">Save</button>
        <button class="btncommon btn-border" (click)="OnCancel()">Cancel</button>
    </div>
</div>